import React from 'react'
import * as ReactDOM from 'react-dom/client'
import App from './App'
import getRootElementAndDataAndKeys from '@newswebsiteapp/shared/react/utils/getRootElementAndDataAndKeys'
import CommonProviders from '@newswebsiteapp/shared/react/CommonProviders'

function nonDefaultDonationRecipient_name_to_id({ selectedNonDefaultDonationRecipient_name, non_default_recipients }) {
  if (selectedNonDefaultDonationRecipient_name === null) { return null }

  if (typeof selectedNonDefaultDonationRecipient_name !== 'string') {
    throw new Error(`invalid ${selectedNonDefaultDonationRecipient_name}`)
  }

  const non_default_recipient = non_default_recipients.find(x => x.name === selectedNonDefaultDonationRecipient_name)

  if (!non_default_recipient && appEnvRails !== 'production') {
    throw new Error(`cannot find non_default_recipient ${selectedNonDefaultDonationRecipient_name}`)
  }

  return non_default_recipient.id
}

export default function renderDonateApp({ url, selectedNonDefaultDonationRecipient_name }) {
  const modalFields_note_show = false
  const {
    recaptchaSiteKey,
    recaptchaSiteKey_disabled,
    dataFromServer,
    collectJSPromise,
    rootElement,
  } = getRootElementAndDataAndKeys({
    rootElementId: '#react-donation-widget-root',
    modalFields_note_show,
  })

  const selectedNonDefaultDonationRecipient_id = nonDefaultDonationRecipient_name_to_id({
    selectedNonDefaultDonationRecipient_name,
    non_default_recipients: dataFromServer.non_default_recipients,
  })

  ReactDOM.createRoot(rootElement).render(
    <CommonProviders collectJSPromise={collectJSPromise}>
      <App
        recaptchaSiteKey={recaptchaSiteKey}
        recaptchaSiteKey_disabled={recaptchaSiteKey_disabled}
        dataFromServer={dataFromServer}
        modalFields_note_show={modalFields_note_show}
        url={url}
        selectedNonDefaultDonationRecipient_id={selectedNonDefaultDonationRecipient_id}
      />
    </CommonProviders>,
  )
}
